/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemNavigation.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System Navigation API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:38 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/17/2018  NJN     Add Components and Component Pages
 *      09/18/2018  NJN     Add Navs, NavPath
 *      09/21/2018  NJN     Add NavTree, NavTreeForReactCheckboxTree, 
 *                          NavTreeRoles, RoleNavs
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const NavGroups = {
    all: () => requests.get('/NavGroups'),
    get: navgroupid => requests.get(`/NavGroup/${navgroupid}`),
    create: navgroup => requests.post(`/NavGroups`, navgroup),
    update: (navgroupid, navgroup) => requests.put(`/NavGroup/${navgroupid}`, navgroup),
    delete: navgroupid => requests.del(`/NavGroup/${navgroupid}`),
};

export const Navs = {
    all: (navgroupid, parentid) => requests.get(`/Navs?navgroupid=${navgroupid ? navgroupid : 0}&parentid=${parentid ? parentid : 0}`),
    get: navid => requests.get(`/Nav/${navid}`),
    create: nav => requests.post(`/Navs`, nav),
    update: (navid, nav) => requests.put(`/Nav/${navid}`, nav),
    delete: (navid, navgroupid, parentid) => requests.del(`/Nav/${navid}?navgroupid=${navgroupid ? navgroupid : 0}&parentid=${parentid ? parentid : 0}`),
};

export const NavPath = {
    get: parentid => requests.get(`/NavPath/${parentid}`)
};

export const NavTree = {
    postget: (payload) => requests.post(`/NavTree`, payload)
};

export const NavTreeForReactCheckboxTree = {
    get: navgroupid => requests.get(`/NavTreeForReactCheckboxTree/${navgroupid}`)
}

export const NavTreeRoles = {
    get: (navgroupid, roleid) => requests.get(`/NavTreeRoles/${navgroupid}/${roleid}`)
};

export const RoleNavs = {
    update: (roleid, rolenavs) => requests.post(`/RoleNavs/${roleid}`, rolenavs)
};

export const NavTypes = {
    all: () => requests.get('/NavTypes'),
    get: navtypeid => requests.get(`/NavType/${navtypeid}`),
    create: navtype => requests.post(`/NavTypes`, navtype),
    update: (navtypeid, navtype) => requests.put(`/NavType/${navtypeid}`, navtype),
    delete: navtypeid => requests.del(`/NavType/${navtypeid}`),
};

export const ComponentGroups = {
    all: () => requests.get('/ComponentGroups'),
    get: componentgroupid => requests.get(`/ComponentGroup/${componentgroupid}`),
    create: componentgroup => requests.post(`/ComponentGroups`, componentgroup),
    update: (componentgroupid, componentgroup) => requests.put(`/ComponentGroup/${componentgroupid}`, componentgroup),
    delete: componentgroupid => requests.del(`/ComponentGroup/${componentgroupid}`),
};

export const Components = {
    all: (componentgroupid) => requests.get(`/Components?componentgroupid=${componentgroupid ? componentgroupid : 0}`),
    get: componentid => requests.get(`/Component/${componentid}`),
    create: component => requests.post(`/Components`, component),
    update: (componentid, component) => requests.put(`/Component/${componentid}`, component),
    delete: componentid => requests.del(`/Component/${componentid}`),
};

export const ComponentPages = {
    all: (componentgroupid, componentid) => requests.get(`/ComponentPages?componentgroupid=${componentgroupid ? componentgroupid : 0}&componentid=${componentid ? componentid : 0}`),
    get: componentpageid => requests.get(`/ComponentPage/${componentpageid}`),
    create: componentpage => requests.post(`/ComponentPages`, componentpage),
    update: (componentpageid, componentpage) => requests.put(`/ComponentPage/${componentpageid}`, componentpage),
    delete: componentpageid => requests.del(`/ComponentPage/${componentpageid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentSystemNavigation.js